// extracted by mini-css-extract-plugin
export default {"section":"RouteContent_section","description":"RouteContent_description"};